var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<h1>Change Password</h1>\n<wb-change-password member=\"client\"></wb-change-password>";
var id1="templates/member/steps/change_password.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../src/public/templates/member/steps/change_password.html
// module id = 1270
// module chunks = 0